module.exports = __webpack_public_path__ + "media/brantonPoster2.40d1c041.mp4";